import Container from './BackLink-container';

export interface ViewComponentChildrenArgs {
  handleClick: () => void;
}

interface ViewComponentProps {
  /**
   * Children
   */
  children: (args: ViewComponentChildrenArgs) => JSX.Element;
}

const ViewComponent = ({ children }: ViewComponentProps) => (
  <Container>{({ handleClick }) => children({ handleClick })}</Container>
);

ViewComponent.displayName = 'BackLink';

export default ViewComponent;
